<template>
    <div class="container">
        <div class="title">
            <img src="./../assets/image/logo.png" alt="" width="360">
            <div class="txt">
                <span>面向“一带一路”的海外仓储管理虚拟仿真实验系统v1.0</span>
                <span>VIRTUAL SIMULATION EXPERIMENT OF OVERSEAS WAREHOUSE OPERATION FOR "ONE BELT ONE ROAD</span>
            </div>
        </div>
        <div class="content">
            <div class="student">
                <img src="./../assets/image/touxiang.jpg" alt="" width="52" height="52">
                <div class="name">
                    {{student.realName}}
                </div>
                <div class="other">
                    <span>
                        学校： {{ student.schoolName }}
                    </span>
                    <span>
                        班级： {{ student.className }}
                    </span>
                    <span>
                        学号： {{ student.studentNo }}
                    </span>
                    <span class="logout" @click="logout">
                        退出登录
                    </span>
                </div>
            </div>
            <div class="experiment">
                <div class="start" @click="start">
                    开始新实验
                </div>
<!--                <div class="continue">-->
<!--                    <span>2020 / 09 / 01 09:45</span>-->
<!--                    <span>查看历史</span>-->
<!--                </div>-->
<!--                <div class="continue">-->
<!--                    <span>2020 / 09 / 01 09:45</span>-->
<!--                    <span>查看历史</span>-->
<!--                </div>-->
                <a class="manage" href="/th" v-if="$store.state.student.type === 1">
                    管理端
                </a>

            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "start",
        data(){
            return {
                student:{}
            }
        },
        created() {
            this.axios.get('/login/current').then(res => {
                this.student = res.student
                this.$store.commit('setState', {key: 'student', value: res.student})
            })
        },
        methods:{
            logout(){
                this.axios.get('/login/logout').then(() => {
                    this.$router.push('/')
                })
            },
            start(){
                this.$store.commit('init')
                this.$router.push('/goods-collection/selectt')
            }
        }
    }
</script>

<style scoped lang="scss">
    div.container {
        width: 100%;
        height: 100%;
        background: url("./../assets/image/login-bg.jpg");
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        > .title {
            display: flex;
            align-items: center;
            margin-bottom: 50px;

            img {
                margin-right: 30px;
            }

            > .txt {
                display: flex;
                flex-direction: column;
                align-items: flex-start;

                > span {
                    font-weight: bolder;
                    font-size: 42px;

                    &:last-child {
                        font-size: 16px;
                        font-weight: normal;
                    }
                }
            }
        }
        > .content {
            width: 968px;
            height: 588px;
            border-radius: 20px;
            background: #FFFFFF;
            padding: 38px 94px;
            .student {
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                margin-bottom: 30px;
                > .name {
                    font-weight: bolder;
                    font-size: 18px;
                    color: #2c3e50;
                }
                > img {
                    margin-bottom: 6px;
                }
                .other {
                    margin-top: 30px;
                    width: 780px;
                    height: 60px;
                    border-bottom: 1px solid #000000;
                    display: flex;
                    justify-content: space-evenly;
                    align-items: center;
                    > .logout {
                        border:1px solid #9e9e9e;
                        border-radius: 50px;
                        padding: 2px 10px;
                        transition: background-color 0.3s linear;
                        cursor: pointer;
                        &:hover {
                            background: #FBB521;
                            transition: background-color 0.3s linear;
                        }
                    }
                }
            }
            .experiment {
                display: flex;
                flex-direction: column;
                align-items: center;
                > div,a {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 396px;
                    height: 48px;
                    border-radius: 50px;
                    color: #FFFFFF;
                    margin-bottom: 12px;
                    cursor: pointer;
                    &:hover {
                        opacity: 0.8;
                    }
                    &.start {
                        justify-content: center;
                        font-size: 20px;
                        font-weight: bolder;
                        background: #FBB521;
                    }
                    &.continue {
                        padding: 0 46px;
                        background: #004BFF;
                    }
                    &.manage {
                        justify-content: center;
                        font-size: 20px;
                        font-weight: bolder;
                        background: #FF1A8C;
                    }
                }
            }
        }
    }
</style>
